var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.activeUserInfo.Nombre)?_c('div',[_c('div',{staticClass:"logout",staticStyle:{"cursor":"pointer"},attrs:{"id":"logout"},on:{"click":_vm.logout}},[_vm._v(" Cerrar sesión ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }